import React from 'react';
import { useFileUploadMutation } from 'src/data-capture/hooks/useFileUploadMutation';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

type UploadTemplateInput = {
  companyId: string;
  templateType: string;
  file: File;
  fileName?: string | undefined;
};

export const useCreateTemplateMutation = () => {
  const [isLoading, setIsLoading] = React.useState(false);

  const { uploadToFileStorage } = useFileUploadMutation();

  const uploadTemplate = async ({
    companyId,
    file,
    templateType,
    fileName = undefined,
  }: UploadTemplateInput) => {
    setIsLoading(true);
    await uploadToFileStorage({ file });
    const createFileResponse = await fetch(
      `${API_URL}/admin/companies/${companyId}/data-export-templates`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fileName: fileName || file.name,
          templateType,
          fileSize: file.size,
          fileType: file.type,
        }),
        credentials: 'include',
      },
    );
    if (!createFileResponse.ok) {
      throw new Error('Failed to create template');
    }
    setIsLoading(false);
  };

  return {
    createTemplate: uploadTemplate,
    isLoading,
  };
};
